// common/components/Can.jsx
import { useContext } from 'react';
import { AuthContext } from '../common/constants';

// Rôles ayant accès complet
const FULL_ACCESS_ROLES = ['superAdmin', 'directeur', 'support'];

export default function Can({ perm, anyOf = [], children }) {
  const { currentUser } = useContext(AuthContext);

  // Rôles avec accès complet
  if (FULL_ACCESS_ROLES.includes(currentUser?.role)) {
    return children;
  }

  const perms = new Set(currentUser?.permissions || []);
  const okOne = anyOf.length ? anyOf.some(p => perms.has(p)) : true;
  const okSingle = perm ? perms.has(perm) : true;
  return (okOne && okSingle) ? children : null;
}
